import { useAtom } from 'jotai';
import { useCallback } from 'react';

import { imagePreviewAtom } from '../atom';

export function useImagePreviewService() {
  const [config, setConfig] = useAtom(imagePreviewAtom);

  const openPreview = useCallback((src: string, alt?: string) => setConfig({ open: true, src, alt }), [setConfig]);

  const closePreview = useCallback(() => setConfig(null), [setConfig]);

  return { config, openPreview, closePreview };
}
